export const fontVariants = [{
  italic: false,
  weight: 100
}, // Thin
{
  italic: true,
  weight: 100
}, // Thin Italic
{
  italic: false,
  weight: 200
}, // Extra Light
{
  italic: true,
  weight: 200
}, // Extra Light Italic
{
  italic: false,
  weight: 300
}, // Light
{
  italic: true,
  weight: 300
}, // Light Italic
{
  italic: false,
  weight: 400
}, // Regular
{
  italic: true,
  weight: 400
}, // Italic
{
  italic: false,
  weight: 500
}, // Medium
{
  italic: true,
  weight: 500
}, // Medium Italic
{
  italic: false,
  weight: 600
}, // Semi Bold
{
  italic: true,
  weight: 600
}, // Semi Bold Italic
{
  italic: false,
  weight: 700
}, // Bold
{
  italic: true,
  weight: 700
}, // Bold Italic
{
  italic: false,
  weight: 800
}, // Extra Bold
{
  italic: true,
  weight: 800
}, // Extra Bold Italic
{
  italic: false,
  weight: 900
}, // Black
{
  italic: true,
  weight: 900
} // Black Italic
]; // Maps display font names to their CSS `font-family` equivalents.
// Ensures correct font rendering and search functionality
// by translating user-facing names (e.g., "Sans Serif")
// to valid CSS values (e.g., "sans-serif").

export const fontNameAlias = {
  'Sans Serif': 'sans-serif'
};
export default {
  fonts: [{
    name: 'Sans Serif',
    sane: 'sans-serif',
    cased: 'Sans Serif',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'serif',
    sane: 'serif',
    cased: 'Serif',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Arial',
    sane: 'arial',
    cased: 'Arial',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Helvetica',
    sane: 'helvetica',
    cased: 'Helvetica',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Times New Roman',
    sane: 'times-new-roman',
    cased: 'Times New Roman',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Times',
    sane: 'times',
    cased: 'Times',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Courier New',
    sane: 'courier-new',
    cased: 'Courier New',
    category: 'monospace',
    variants: fontVariants
  }, {
    name: 'Courier',
    sane: 'courier',
    cased: 'Courier',
    category: 'monospace',
    variants: fontVariants
  }, {
    name: 'Palatino',
    sane: 'palatino',
    cased: 'Palatino',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Garamond',
    sane: 'garamond',
    cased: 'Garamond',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Bookman',
    sane: 'bookman',
    cased: 'Bookman',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Avant Garde',
    sane: 'avant-garde',
    cased: 'Avant Garde',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Verdana',
    sane: 'verdana',
    cased: 'Verdana',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Georgia',
    sane: 'georgia',
    cased: 'Georgia',
    category: 'serif',
    variants: fontVariants
  }, {
    name: 'Comic Sans MS',
    sane: 'comic-sans-ms',
    cased: 'Comic Sans MS',
    category: 'handwriting',
    variants: fontVariants
  }, {
    name: 'Trebuchet MS',
    sane: 'trebuchet-ms',
    cased: 'Trebuchet MS',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Arial Black',
    sane: 'arial-black',
    cased: 'Arial Black',
    category: 'sans-serif',
    variants: fontVariants
  }, {
    name: 'Impact',
    sane: 'impact',
    cased: 'Impact',
    category: 'display',
    variants: fontVariants
  }]
};